'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var noflip = {};

exports.__exports = noflip;
